<script>
    import TableTemplate from "@itslearning/prometheus/assets/templates/Table/v1/Table.svelte";
    import Table from "@itslearning/prometheus/assets/lists/Table/v1/Table.svelte";
    import TableData from "@itslearning/prometheus/assets/lists/Table/v1/TableData.svelte";
    import TableHeader from "@itslearning/prometheus/assets/lists/Table/v1/TableHeader.svelte";
    import TableRow from "@itslearning/prometheus/assets/lists/Table/v1/TableRow.svelte";
    import TableDataLink from "@itslearning/prometheus/assets/lists/Table/v1/TableDataLink.svelte";
    import config from "../../config";
    // Declare the props to receive the `config` data

    // Access specific properties from the `config` object
    let courses = config.courses;
    const customerId = config.customerId;
    const languageId = config.languageId;
    const i18n = config.i18n;
    const urlLink = "/Courses/ExternalCourseCatalogue/CourseInfo";
    const homeUrl = "/";
</script>
<svelte:head>
    <title>{i18n.external_Course_catalogue}</title>
</svelte:head>

<TableTemplate
    pageTitle={i18n.external_Course_catalogue}
    emptyStateTitle={i18n.no_courses}
    backLinkUrl={homeUrl}
    backLinkText={i18n.back_to_login_page}
    bind:tableItems={courses}
>
    <Table
        caption={i18n.list_of_courses_in_the_course_catalog}
        hideCaption
    >
        <TableRow slot="thead">
            <TableHeader text={i18n.title} />
            <TableHeader text={i18n.course_information_Free_spots} />
        </TableRow>

            {#each courses as course}
                <TableRow>
                    <TableDataLink
                        href={`${urlLink}?CourseID=${course.courseId}&CustomerID=${customerId}&LanguageID=${languageId}&Unknown=true`}
                        target="_blank"
                        text={course?.courseTitle}
                    />
                    <TableData
                        text={course?.numberOfFreeSeats ??
                            i18n.course_information_Free_spots_not_stated}
                    />
                </TableRow>
            {/each}
    </Table>
</TableTemplate>
